'use client';
import { createContext, useContext, useLayoutEffect, useState } from 'react';
import {
  THEMES,
  defaultTheme,
  normalizeTheme,
  isDarkTheme,
} from '@/constants/themes';

const ThemeContext = createContext();

const applyTheme = (themeId, element) => {
  if (!element) return;
  THEMES.forEach((t) => element.classList.remove(t.id));
  element.classList.add(themeId);
  element.setAttribute('data-theme', themeId);
  if (isDarkTheme(themeId)) {
    element.classList.add('dark');
  } else {
    element.classList.remove('dark');
  }
};

export const ThemeProvider = ({ children, initialTheme, themeRoot }) => {
  const normalized = normalizeTheme(
    initialTheme || (typeof localStorage !== 'undefined' ? localStorage.getItem('theme') : null)
  );
  const [theme, setThemeState] = useState(normalized);

  useLayoutEffect(() => {
    const saved = normalizeTheme(initialTheme || localStorage.getItem('theme') || defaultTheme);
    setThemeState(saved);
    applyTheme(saved, themeRoot);
  }, [initialTheme, themeRoot]);

  // const setTheme = (themeId) => {
  //   const next = normalizeTheme(themeId);
  //   setThemeState(next);
  //   applyTheme(next);
  //   localStorage.setItem('theme', next);
  // };

  // const toggleTheme = () => {
  //   const idx = THEMES.findIndex((t) => t.id === theme);
  //   const next = THEMES[(idx + 1) % THEMES.length];
  //   setTheme(next.id);
  // };

  return (
    <ThemeContext.Provider value={{ theme , isDark: isDarkTheme(theme) }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
